import PageTypeC from "../components/pageTypeC/PageTypeC";
import { pagesDataC } from "../data/pagesData";

const Page9 = () => {
  return (
    <PageTypeC
      title={pagesDataC[1].title}
      text1={pagesDataC[1].text1}
      text2={pagesDataC[1].text2}
      text3={pagesDataC[1].text3}
      imageLeft={pagesDataC[1].imageLeft}
      imageCenter={pagesDataC[1].imageCenter}
      imageRight={pagesDataC[1].imageRight}
    />
  );
};

export default Page9;
